<template>
  <v-content>
    <the-header menuTitle="Campaign Detail"/>
    <v-container class="page-wrapper" style="min-height: 700px;">
      <div class="text-xs-center" v-if="dialog">
         <v-dialog
            v-model="dialog"
            hide-overlay
            persistent
            width="300"
          >
               <v-card
                  color="primary"
                  dark
                >
                  <v-card-text>
                    Please stand by
                    <v-progress-linear
                      indeterminate
                      color="white"
                      class="mb-0"
                    ></v-progress-linear>
                  </v-card-text>
              </v-card>
          </v-dialog>
      </div>

      <div v-else>
      	<CampaignDetail></CampaignDetail>
    	  <FlightList></FlightList>
      </div>
    </v-container>
    <!--  <the-footer style="margin-bottom:-44px" /> -->

  </v-content>

</template>

<script>
 //
 // import { mapState } from 'vuex';
  import TheHeader from "@/components/TheHeader";
  //import TheFooter from "@/components/TheFooter";
  import CampaignDetail from '@/components/CampaignDetail'
  import FlightList from '@/components/FlightList'
 // import HelloWorld from '@/components/HelloWorld'

  export default {
    name:'detail',
    components: {
      TheHeader,
      //TheFooter,
      CampaignDetail,
      FlightList,

    },
    data () {
      return {
        dialog: false
      }
    },
    methods:{
       getsalePrivilege(){
              this.$store.dispatch('checkCampaignAccess')
               .then(() =>

                  this.loading =false

                )
               .catch(err => {
                  console.log(err )

               })

               // return  loginService.getAIOAcess().then((data)=>{
               //      return data.approve_flight_request;
               //  });
          },
    },
    async beforeUpdate(){
      // if (this.userId){
      //   await this.getsalePrivilege()
      //  // console.log( this.isSalePrivilege)
      // }
     //console.log( storage.getItem('subscription') )
   //   console.log(this.$store.state.isSalePrivilege)


  },
   mounted(){

    //console.log(this.$store.state.isLoading);
      this.dialog = this.$store.state.isLoading
      //console.log(this.dialog)
    },
    watch: {
      dialog (val) {
        if (!val) return

        setTimeout(() => (this.dialog = false), 4000)
      }
    }

  }
</script>
